module.exports = __webpack_public_path__ + "img/features_8.86f46990.png";